import { BRAND_ACCENT, BRAND_PLAIN, NAV_LINKS } from "./data";
import { useSmoothScroll } from "../../App";

export default function Footer() {
  const scrollTo = useSmoothScroll();
  return (
    <footer data-testid="site-footer" className="border-t border-ivory/10 bg-forest">
      <div className="mx-auto max-w-editorial px-6 py-20 text-center md:px-10 md:py-24">
        <p className="font-serif text-4xl font-light text-ivory md:text-5xl">
          {BRAND_PLAIN} <em className="text-saffron">{BRAND_ACCENT}</em>
        </p>
        <p className="mt-4 font-serif text-lg italic text-ivory/60">
          A Wildlife Photography &amp; Slow Travel Journey
        </p>

        <nav aria-label="Footer" className="mt-10 flex flex-wrap items-center justify-center gap-x-10 gap-y-4">
          {NAV_LINKS.map((l) => (
            <button
              key={l.href}
              data-testid={`footer-link-${l.label.toLowerCase()}`}
              onClick={() => scrollTo(l.href)}
              className="text-[11px] font-medium uppercase tracking-[0.26em] text-ivory/55 transition-colors duration-300 hover:text-saffron"
            >
              {l.label}
            </button>
          ))}
        </nav>

        <p className="mt-12 border-t border-ivory/10 pt-8 text-[10px] uppercase tracking-[0.28em] text-ivory/35">
          © {new Date().getFullYear()} Meet The Gods Ecotrails · All rights reserved
        </p>
      </div>
    </footer>
  );
}
